module.exports = __webpack_public_path__ + "img/div27.6f220a42.png";